import { isNullOrUndefined } from './values';

export const isNumeric = (value: any): value is number | string => {
  if (typeof value === 'number') return isFinite(value);
  if (typeof value === 'string' && value.trim() !== '') {
    const n = Number(value);
    return isFinite(n);
  }
  return false;
};

export const toNumber = (value: number | string): number => {
  if (!isNumeric(value)) {
    throw new Error(`Can't convert non-numeric value ${value} to number`);
  } else {
    return Number(value);
  }
};

export const toNumberOrNull = (value: number | string | null | undefined): number | null => {
  if (isNullOrUndefined(value) || !isNumeric(value)) {
    return null;
  } else {
    return toNumber(value);
  }
};
